import React from 'react';
import PropTypes from 'prop-types';
import { TextStyle } from '@lavu-pos/lavu-react-components';
import styled, { css } from 'styled-components';
import { Colors } from '../../index';

const sectionShareStyle = css`
	background: ${Colors.DARK_WHITE};
	overflow: auto;
	padding: 15px;
`;

const SubsectionWrapperStyle = styled.div`
	&:first-child {
		border: 0;
	}
	page-break-inside: ${({ stickToParent }) =>
		stickToParent ? 'auto' : 'avoid'};
	${({ bordered }) =>
		bordered &&
		`
		border: 1px solid ${Colors.LIGHT_GREY};
  `};

	${({ hideBorderTop }) => hideBorderTop && `border-top: 0;`};
`;

const SubsectionHeaderStyle = styled.div`
	display: flex;
	padding: 15px;
	min-height: 45px;
	align-items: center;
	background: ${Colors.WHITE};
	border-bottom: solid 1px ${Colors.LIGHT_GREY};

	${({ stickyHeader }) =>
		stickyHeader &&
		`
			position: sticky;
			z-index: 1;
			top: 0;
	`};
`;

const SubsectionBodyStyle = styled.div`
	${sectionShareStyle};
	overflow: visible;
`;

const propTypes = {
	title: PropTypes.node,
	children: PropTypes.node,
	bodyStyles: PropTypes.object,
	stickyHeader: PropTypes.bool,
	bordered: PropTypes.bool,
	stickToParent: PropTypes.bool,
	hideBorderTop: PropTypes.bool,
	elementId: PropTypes.string,
	isPrintable: PropTypes.bool,
};

const defaultProps = {
	bodyStyles: {},
	stickyHeader: false,
	bordered: false,
	stickToParent: false,
	hideBorderTop: true,
};

const SubSection = ({
	title,
	children,
	bodyStyles,
	stickyHeader,
	bordered,
	stickToParent,
	hideBorderTop,
	elementId,
	isPrintable,
}) => (
	<SubsectionWrapperStyle
		bordered={bordered}
		stickToParent={stickToParent}
		hideBorderTop={hideBorderTop}
	>
		{!isPrintable && (
			<SubsectionHeaderStyle
				className="sub-section-header"
				stickyHeader={stickyHeader}
			>
				<TextStyle fontWeight="bold" fontSize={12} id={`${elementId}-title`}>
					{title}
				</TextStyle>
			</SubsectionHeaderStyle>
		)}
		<SubsectionBodyStyle style={bodyStyles}>{children}</SubsectionBodyStyle>
	</SubsectionWrapperStyle>
);

SubSection.propTypes = propTypes;
SubSection.defaultProps = defaultProps;

export default SubSection;
